export default __webpack_public_path__ + "static/abc-224e6fbf33ec1b6d30608c51f2d86d6a.png";